import React, { useEffect, useState } from 'react';

import './Tooltip.css';

type TooltipProps = {
  content: string;
  maxResolution?: number;
  position?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactNode;
};

export function Tooltip({
  content,
  position = 'bottom',
  children,
  maxResolution = 900,
}: TooltipProps) {
  const [showTooltip, setShowTooltip] = useState(window.innerWidth < maxResolution);

  useEffect(() => {
    const handleResize = () => {
      setShowTooltip(window.innerWidth < maxResolution);
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [maxResolution]);

  if (showTooltip) {
    return (
      <div className="custom-tooltip">
        {children}
        <div className={`custom-tooltip-content ${position}`}>{content}</div>
      </div>
    );
  }

  return children as React.ReactElement;
}
